export class ParserWorkerManager {
  constructor() {
    this.worker = null;
  }

  init() {
    if (!this.worker) {
      this.worker = new Worker(
        new URL("./responseParserWorker.js", import.meta.url),
        { type: "module" }
      );
    }
  }

  destroy() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
  }

  parse(response, options) {
    return new Promise((resolve, reject) => {
      if (!this.worker) {
        this.init();
      }

      this.worker.onmessage = (e) => {
        if (e.data.success) {
          resolve(e.data.data);
        } else {
          const error = new Error('Parser worker error');
          error.workerError = e.data.error;
          error.originalData = e.data.data;
          error.contentType = e.data.contentType;
          reject(error);
        }
      };

      this.worker.onerror = (error) => {
        const err = new Error('Worker runtime error');
        err.originalError = error;
        err.lineNumber = error.lineno;
        err.fileName = error.filename;
        reject(err);
      };

      try {
        this.worker.postMessage({ response, options });
      } catch (error) {
        reject(new Error(`Failed to send data to worker: ${error.message}`));
      }
    });
  }
}
